import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";

export function useLive() {
  const app = useContext(AppContext)!;
  return app.live$;
}
